import styled from "styled-components";

const ListItem = styled.li`
  text-align: center;
  margin: 0.3rem;
`;

const ListItemLabel = styled.h3`
  font-family: "Spline Sans Mono", monospace;
  font-size: 1rem;
`;

export { ListItem, ListItemLabel };
